/** @jsxImportSource @emotion/react */
import {
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '../../../../components/Dialog';
import {Dialog} from '@reach/dialog';
import Img from './DeleteImg.svg';
import {ButtonGroup} from '../../../../components/Button';
import {Button} from '@mayo/mayo-ui-gakki';

type DeleteDialogProps = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
};
export default function DeleteDialog(props: DeleteDialogProps) {
  const {isOpen, text = '確定要刪除嗎?', onCancel, onConfirm} = props;
  return (
    <Dialog isOpen={isOpen} className={'delete-dialog'} aria-label="delete-dialog">
      <DialogTitle title="刪除資料" customStyle={{ fontWeight: 400 }} onClose={onCancel} showCloseButton />
      <DialogContent>
        <p css={{marginTop: 16, fontSize: 14}}>{text}</p>
        <img src={Img} alt="deleteImg" />
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
        <Button
            variant={'outline'}
            colorSchema={'primary'}
            onClick={onConfirm}
            aria-label="confirm-btn"
          >
            確定
          </Button>
          <Button
            variant={'solid'}
            colorSchema={'primary'}
            onClick={onCancel}
            aria-label="cancel-btn"
          >
            取消
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
}
